import React, { useState } from 'react';
import { useTranslation } from '@wienenergiegithub/modules-next/hooks';
import { useTracking } from '@components/hooks';
import { DialogDisclosure, useDialogStore } from '@ariakit/react';
import classNames from 'classnames';
import styles from './Day.module.scss';
import { FontAwesomeProIcon, Image } from '@wienenergiegithub/ui-next';
import PropTypes from 'prop-types';
import DayModal from './DayModal';
import { dayActiveCenterShape, dayActiveLeftShape } from '../assets';

const Day = ({
  dayNumber,
  details,
  icon,
  modalImage,
  modalTitle,
  status,
  subtitle,
  unavailableCtaText,
  url,
}) => {
  const [isAnimated, setIsAnimated] = useState(false);
  const track = useTracking();
  const dialog = useDialogStore({ animated: true });

  const trackInteraction = action => {
    track({
      event: 'vorteilskalender',
      eventCategory: 'vorteilskalender',
      eventAction: action,
      eventName: `tag${dayNumber}`,
    });
  };

  const onModalClose = action => {
    trackInteraction(action);
    dialog.hide();
  };

  return (
    <>
      <DialogDisclosure
        aria-label={`Tag ${dayNumber} öffnen`}
        className={classNames(styles.container, {
          [styles.isUpcoming]: status === 'upcoming',
          [styles.isActive]: status === 'active',
          [styles.animation]: isAnimated && status !== 'upcoming',
        })}
        disabled={status === 'upcoming'}
        onClick={() => trackInteraction('oeffnen')}
        onMouseEnter={() => setIsAnimated(true)}
        onMouseLeave={() => setIsAnimated(false)}
        store={dialog}
      >
        {status === 'active' && (
          <>
            <Image
              className={styles.activeCenterShape}
              src={dayActiveCenterShape}
            />
            <Image
              className={styles.activeLeftShape}
              src={dayActiveLeftShape}
            />
          </>
        )}
        <div
          className={classNames(styles.numbers, {
            [styles.isUpcoming]: status === 'upcoming',
            [styles.isActive]: status === 'active',
          })}
        >
          {dayNumber}
        </div>
        {status === 'expired' && <div className={styles.previouslyOpened} />}
        {!!icon && (
          <FontAwesomeProIcon
            className={classNames(styles.icon, {
              [styles.isUpcoming]: status === 'upcoming',
              [styles.customIcon]: icon === 'rathaus' || icon === 'stephansdom',
            })}
            icon={icon}
            size="4x"
          />
        )}
      </DialogDisclosure>
      {status !== 'upcoming' && (
        <DayModal
          details={details}
          modalImage={modalImage}
          modalTitle={modalTitle}
          onModalClose={onModalClose}
          status={status}
          store={dialog}
          subtitle={subtitle}
          trackInteraction={trackInteraction}
          unavailableCtaText={unavailableCtaText}
          url={url}
        />
      )}
    </>
  );
};

Day.propTypes = {
  dayNumber: PropTypes.string.isRequired,
  details: PropTypes.string,
  icon: PropTypes.string,
  modalImage: PropTypes.string,
  modalTitle: PropTypes.string,
  status: PropTypes.oneOf(['upcoming', 'active', 'expired']).isRequired,
  subtitle: PropTypes.string,
  unavailableCtaText: PropTypes.string,
  url: PropTypes.string,
};

export default Day;
